import { MouseEventHandler, ReactNode } from "react";
import classNames from "classnames";

const activeStyles = {
  outline: "2px solid var(--dropdown-selected-dark)",
  background: "var(--dropdown-selected)",
  color: "var(--dark)",
};

const unactiveStyles = {
  outline: "1px solid var(--light)",
};

interface AppFieldCardProps {
  onClick: MouseEventHandler<HTMLDivElement> | undefined;
  isSelected: boolean;
  icon: string;
  name: string;
  description: string;
  full?: boolean;
  css?: string;
  innerCSS?: string;
  disabled?: boolean;
  vectorIcon?: boolean;
  options: ReactNode;
}

const AppFieldCard = ({
  onClick,
  isSelected,
  icon,
  name,
  description,
  full,
  css,
  innerCSS,
  disabled = false,
  vectorIcon = false,
  options,
}: AppFieldCardProps) => {
  return (
    <div
      className={classNames("cursor-pointer", {
        "w-50": !full,
        "w-100": full,
        [css ? css : ""]: !!css,
      })}
      onClick={disabled ? undefined : onClick}
    >
      <div
        className={classNames(
          "tw:flex tw:items-center p-2 rounded mx-0 my-1 font-weight-500",
          { [innerCSS ? innerCSS : ""]: !!innerCSS }
        )}
        style={isSelected ? activeStyles : unactiveStyles}
      >
        <div>
          {vectorIcon ? (
            <img
              src={icon}
              style={{ height: 20 }}
              className="pl-2 pr-3 w-100"
              alt="ICON"
            />
          ) : (
            <i
              className={`mdi mdi-${icon} pl-1 pr-3 text-dark`}
              style={{ fontSize: 22 }}
            />
          )}
        </div>
        <div
          style={{ width: "calc(100% - 40px" }}
          className="tw:flex tw:justify-between"
        >
          <div>
            <div className="text-dark">{name}</div>
            <div className="small text-truncate text-muted">{description}</div>
          </div>
          {options}
        </div>
      </div>
    </div>
  );
};

export default AppFieldCard;
